import { render, staticRenderFns } from "./MappingItem.vue?vue&type=template&id=8ee93556"
import script from "./MappingItem.vue?vue&type=script&lang=js"
export * from "./MappingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports